import React from "react";
import Grid from "@material-ui/core/Grid";

const gridStyle = {
  paddingBottom: "5px",
};

const SanitizedGrid = ({ basePath, ...props }: any) => {
  return <Grid style={gridStyle} {...props} />;
};

export default SanitizedGrid;
